module.exports = __webpack_public_path__ + "public/img/640 (4).3274f11f.gif";